exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".previewBackgroundContainer{position:absolute}.editArea{transform-origin:left top;white-space:nowrap;overflow:hidden}.north{width:100%;height:100%}.previewBackgroundContainer{background-size:contain;background-repeat:no-repeat;background-position:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61f8a012","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Preview/Previewbackground.vue
// module id = 63
// module chunks = 0